import axios from 'axios';
import { getBasePath, getILBasePath } from './basePath';

const dashboardAxios = axios.create({
  baseURL: getBasePath(),
});

const dashboardILAxios = axios.create({
  baseURL: getILBasePath(),
});

export function buildAuthenticationHeaders(credentials) {
  return {
    headers: {
      Authorization: `bearer ${credentials.token}`,
    },
  };
}

const getAccountDetails = credentials =>
    dashboardAxios.get(`/hdap/appserver/rest/object/Account/${credentials.accountId}`, {
      ...buildAuthenticationHeaders(credentials)
    });

const getAccountFromVAccount = credentials =>
    dashboardILAxios.get(`/vgateway/vaccount/v2/account/${ credentials.accountId }`, {
      ...buildAuthenticationHeaders(credentials)
    });

export {
  dashboardAxios,
  dashboardILAxios,
  getBasePath,
  getAccountDetails,
  getAccountFromVAccount,
};
